import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import gql from "graphql-tag";

import { config } from "../../config";

const link = createHttpLink({
  uri: config.api.host,
  fetch,
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
    },
    query: {
      fetchPolicy: "no-cache",
    },
  },
});

const query = gql`
  query LoginQuery($username: String!, $password: String!) {
    videoByLogin(username: $username, password: $password) {
      streamUrl
      firstName {
        label
      }
    }
  }
`;

export interface User {
  name: string;
  stream: string;
}

export async function login(username: string, password: string): Promise<User> {
  try {
    const response = await client.query({
      query,
      variables: {
        username,
        password,
      },
    });

    if (response.data?.videoByLogin && response.data.videoByLogin.firstName?.label && response.data.videoByLogin.streamUrl) {
      return {
        name: response.data.videoByLogin.firstName.label,
        stream: response.data.videoByLogin.streamUrl,
      }
    }
  } catch {
    console.log("error catching");
  }

  throw new Error("Santa could not find your username and password. Santa may have sent a new username and password. Please ask a grown up to check their email!");
}



// WEBPACK FOOTER //
// ./src/api/endpoints/user.ts